export default __webpack_public_path__ + "static/media/home-page-third-section.30cbde75.jpg";